import GroupedContent from 'grouped-content';
import fitvids from 'fitvids';

const rtes = new Map();

export default class Rte {
  constructor({ el }) {
    this.el = el;
    if (rtes.has(el)) return;
    rtes.set(this.el, this);
    this.setupTabs();

    fitvids({
      // Ignore external videos within the product gallery.
      ignore: ['.product-gallery--external_video iframe'],
    });
  }

  setupTabs() {
    this.groupedContent = new GroupedContent(this.el, { layout: 'tabs', intelliparse: false });
  }

  unload() {
    if (this.groupedContent) {
      this.groupedContent.unload();
    }

    rtes.delete(this.el);
  }
}
